import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { LoadingSpinner } from "../bits/loading";
import { trpc } from "../../utils/trpc";

export const FrjIssuePage = () => {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();

  const { data, isLoading } = trpc.getFrjPostsByTag.useQuery(
    { tagSlug: `hash-${slug}` },
    { enabled: !!slug },
  );

  useEffect(() => {
    const firstSlug = data?.posts?.[0]?.slug;
    if (firstSlug) {
      navigate(`/article/${firstSlug}`, { replace: true });
    }
  }, [data, navigate]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!isLoading && (!data?.posts || data.posts.length === 0)) {
    return (
      <div
        style={{
          padding: "24px",
          fontFamily: "Spectral",
          fontSize: "16px",
          color: "rgba(18,23,42,0.6)",
        }}
      >
        No articles found for this issue.
      </div>
    );
  }

  return null;
};
